// extracted by mini-css-extract-plugin
export default {"Modal":"ModalComp_Modal__BsaVN","show":"ModalComp_show__tZsHV","modal-fade":"ModalComp_modal-fade__T2+bC","modal-content":"ModalComp_modal-content__7TQXh"};